<div class="grid h-screen">
    @if (homeService.isExternalBoxPlanPage() || homeService.isExternalPage()) {
        <div class="p-4 flex flex-col pb-0 col-span-2 row-span-2">
            <div class="flex flex-row items-center gap-40">
                <img
                    alt="ConnectServices logo"
                    fetchpriority="high"
                    height="36"
                    src="assets/images/logo/connect_services_logo_black.png"
                    width="140" />
                @if (layerName()) {
                    <div class="flex items-center gap-2">
                        <h2 class="!m-0 !font-normal">{{ layerName() }}</h2>

                        @if (createState().visible) {
                            <app-create-entity-button
                                [disabled]="createState().disabled"
                                [tooltipKey]="createState().tooltipKey"
                                (clicked)="onCreateClickExternal()" />
                        }

                        @if (hasExternalLayerPendingEdits()) {
                            <span class="tab-edit-badge"></span>
                        }
                    </div>
                }

                @if (selectSynopticService.selectedDeposit()) {
                    <div class="font-semibold text-xl">{{ selectSynopticService.selectedDeposit()?.name }}</div>
                }
            </div>

            <div
                class="gridContent flex-1 mt-4"
                [class]="contentLayoutService.mapSizeType()?.class">
                <div
                    class="bg-white rounded-xl w-full overflow-x-auto"
                    [class]="isPanelScrollableY() ? '' : 'overflow-y-hidden'"
                    [class.external-page-content]="!layerName()"
                    [class.panel]="layerName()">
                    <router-outlet />
                </div>
                @if (layerName()) {
                    <div
                        class="map rounded-xl min-w-0 overflow-hidden border-solid border-3"
                        [class]="isExternalTableEditActive() ? 'border-custom-blue' : 'border-transparent'">
                        <app-entity-table [editModeCapabilities]="baseCapabilities()" />
                    </div>
                }
            </div>
        </div>
    } @else {
        <div class="col-span-2">
            <app-topbar />
        </div>
        <div class="sidebar">
            <app-sidebar class="w-full flex flex-col items-center" />
            <div
                class="faq"
                (click)="faqService.redirect()">
                <fa-icon
                    size="xl"
                    [icon]="['fas', 'question']" />

                <p>FAQ</p>
            </div>
        </div>

        <app-content-toolbar class="mr-2" />
        <div class="content col-start-2 row-span-2">
            <div
                class="gridContent"
                [class]="contentLayoutService.mapSizeType()?.class">
                <div
                    class="panel rounded-xl w-full overflow-x-auto"
                    [class.overflow-y-hidden]="!isPanelScrollableY()">
                    <router-outlet />
                </div>
                <div
                    class="map rounded-xl min-w-0 overflow-hidden border-solid border-3"
                    [class]="
                        isEditModeActive() && contentLayoutService.isDataTableView()
                            ? 'border-custom-blue'
                            : 'border-transparent'
                    ">
                    @if (contentLayoutService.isDataTableView() && isSubscriptionLoaded()) {
                        <app-entity-table [editModeCapabilities]="baseCapabilities()" />
                    } @else {
                        <div class="map-and-streetview flex flex-col rounded-xl min-w-0 overflow-hidden h-full gap-2">
                            <div
                                class="flex-1 rounded-xl overflow-hidden relative w-full"
                                [class]="
                                    immersiveViewUiService.isPanelOpened() &&
                                    immersiveViewService.isImmersiveViewActive()
                                        ? 'h-1/3'
                                        : 'h-full'
                                ">
                                @if (isSubscriptionLoaded()) {
                                    <app-map
                                        [canBasemap]="
                                            !createFieldInterventionService.isCreateFieldIntervention() &&
                                            !entitiesTableByLayerService.isFieldInterventionSelectionActive() &&
                                            !statisticService.isStatisticActive()
                                        "
                                        [canClickFeature]="
                                            !entitiesTableByLayerService.isFieldInterventionSelectionActive()
                                        "
                                        [canMapExport]="canExportFromServices()"
                                        [canUseGeographicFilter]="
                                            geographicFilterService.isGeographicFilterAllowedOnComponent()
                                        "
                                        [center]="homeService.center()"
                                        [editModeCapabilities]="baseCapabilities()"
                                        [sources]="sourcesService.sources()" />
                                    @if (
                                        immersiveViewService.isImmersiveViewActive() &&
                                        immersiveViewService.canUseImmersiveView()
                                    ) {
                                        <app-immersive-view-selection />
                                    }
                                }
                            </div>
                            @if (
                                immersiveViewUiService.isPanelOpened() && immersiveViewService.isImmersiveViewActive()
                            ) {
                                <div class="relative h-2/3 w-full min-h-0 overflow-hidden rounded-xl bg-white">
                                    <app-immersive-view class="absolute inset-0 block overflow-hidden rounded-xl" />
                                </div>
                            }
                        </div>
                    }
                </div>
                <div class="detail-panel relative rounded-xl bg-white w-full overflow-y-auto">
                    <router-outlet
                        name="detailPanel"
                        (activate)="pinService.close()" />
                </div>
            </div>
        </div>
    }
    <div class="footer col-span-2 text-center">
        <app-version class="ml-8 text-on-surface text-caption" />
    </div>
</div>
